import { t } from 'ttag';
import { getSearchParam } from '../browser';

/**
 * Detects whether the portal is running inside the native webview's create-study flow. Requires the isWebView search parameter to be true together with either a to parameter of /studies or a pathname under /studies/.
 *
 * @returns True when the current location is the webview create-study flow.
 */
const isWebViewCreateStudy = () => {
  const pathName = window.location.pathname;
  return (
    getSearchParam('isWebView') === 'true' &&
    (getSearchParam('to') === '/studies' || pathName.includes('/studies/'))
  );
};

/**
 * Aborts the native webview study-creation flow by reporting a failure back to the host app. Navigates the window to the biotres://end-createstudy/fail deep link carrying the error message, which defaults to a localized unknown-error text, and the study id.
 *
 * @param errorMessage - Message shown by the host app, defaulting to a localized unknown error.
 * @param studyId - Study the failed creation belongs to.
 * @returns Nothing.
 */
const handleThrowErrorWebView = (errorMessage = t`An unknown error occurred!`, studyId = '') => {
  window.location.href = `biotres://end-createstudy/fail?errorMessage=${errorMessage}&studyId=${studyId}`;
};

export { handleThrowErrorWebView, isWebViewCreateStudy };
